import { createFileRoute } from "@tanstack/react-router";
import { useContext, useEffect } from "react";

import UserContext from "@/contexts/user";

import useApiClient from "@/hooks/useApiClient";

export const Route = createFileRoute("/auth/$provider/cookie/callback")({
  component: AuthCallback,
  staticData: { noLayout: true },
});

function AuthCallback() {
  const api = useApiClient();
  const { user, setUser } = useContext(UserContext);
  const { provider } = Route.useParams();

  useEffect(() => {
    if (!user) {
      const params = Object.fromEntries(
        new URLSearchParams(window.location.search)
      );
      const providerService = (api as any)[provider];
      providerService.oauthCookieCallback
        .bind(providerService)(params)
        .then(() => api.users.usersCurrentUser())
        .then(setUser)
        .then(() => {
          const redirect = window.sessionStorage.getItem("redirectUrl") || "/";
          window.sessionStorage.removeItem("redirectUrl");
          window.location.href = redirect;
        })
        .finally();
    }
  }, [api, setUser, user, provider]);

  return <></>;
}
